import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AreaLocalProvider } from '../area-local/area-local';
import { Atalho } from '../../models/atalho';
import { Area } from '../../models/area';
import { BrComService } from '../../service/BrComService'
import { EmpresaLocalProvider } from '../empresa-local/empresa-local';
import { HttpServidor } from '../shared/abstract/http-servidor';

interface dadosAtualizacaoEmpresa {
  atalhos: Atalho[],
  nomeEmpresa: string,
  hashLogotipo: string,
  site: string,
  facebook: string,
  twitter: string,
  areas: Area[],
  layoutRotinas: number,
  tituloSetor: string,
  tituloCentroDeCusto: string
}

@Injectable()
export class EmpresaProvider extends HttpServidor {

  constructor(http: HttpClient, 
    private areaLocalProvider: AreaLocalProvider,
    private empresaLocalProvider: EmpresaLocalProvider,
    private brComService: BrComService
  ) {
    super(http);
  }

  private getInformacoesRecentesDaEmpresa(empresa: any): Observable<dadosAtualizacaoEmpresa> {
    const form = new FormData();
    form.append('cod_empresa', JSON.stringify(empresa.CodEmpresa));
    form.append('id_usuario', JSON.stringify(empresa.IdUsuario));
    form.append('id_device', JSON.stringify(this.brComService.getIdDevice()));
    return this.post('infoEmpresa', form);
  }

  public atualizarEmpresa(): void {
    const empresa = this.empresaLocalProvider.getEmpresa();
    if (!empresa) {
      return
    }
    this.getInformacoesRecentesDaEmpresa(empresa).subscribe(
      (dados: dadosAtualizacaoEmpresa) => {
        this.areaLocalProvider.setAreas(dados.areas);
        empresa.Atalhos = dados.atalhos;
        empresa.HashLogotipoEmpresa = dados.hashLogotipo;
        empresa.NomeEmpresa = dados.nomeEmpresa;
        empresa.Site = dados.site;
        empresa.Facebook = dados.facebook;
        empresa.Twitter = dados.twitter;
        empresa.LayoutRotinas = dados.layoutRotinas;
        empresa.TituloSetor = dados.tituloSetor;
        empresa.TituloCentroDeCusto = dados.tituloCentroDeCusto;
        this.empresaLocalProvider.setEmpresa([empresa]);
      }
    )
  }



}



// WEBPACK FOOTER //
// ./src/providers/empresa/empresa.ts